const generalMasterRouteList = {
    addOrEdit: "add-or-edit",
    doctorMaster:"doctor-master",
    doctorTimeSlot:"time-slot",
    doctorLicense:"doctor-license",
    clinician: "clinician",
    appointmentTypeMaster:"appointment-type-master",
    employeeMaster:"employee-master",
    uomMaster:"uom-master",
    countryMaster:"country-master",
    stateMaster:"state-master",
    companyMaster:"company-master",
    purposeMaster:"purpose-master",
    accountTag:"account-tag-master",
    accountCategory:"account-category-master",
    drugMaster:"drug-master",
    specialityMaster:"speciality-master",
}

export default generalMasterRouteList